<div class="daisy-card daisy-card-bordered bg-base-100">
  <div class="daisy-card-body custom-card-section">
    <div class="flex flex-wrap">
      <div class="w-full md:w-10/12 title-container">
        <h5>{{ title }}</h5>
      </div>
      <div class="w-full md:w-2/12">
        <div class="button-container">
          <button
            style="margin-right: 8px"
            (click)="delete()"
            class="daisy-btn daisy-btn-sm daisy-btn-warning custom-button"
          >
            <i class="fa-solid fa-trash"></i>
          </button>
          <button
            class="daisy-btn daisy-btn-outline daisy-btn-sm custom-button"
            (click)="fireToggle()"
          >
            {{ expanded ? '-' : '+' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
